import React from 'react';
import Container from '@material-ui/core/Container';
import PrivateLayout from '../../../layouts/private';
import UpdateProfileComponent from './update-profile-component';

class UpdateProfileScreen extends React.Component {

    render() {
        return (
            <PrivateLayout screenTitle="Update Profile">
                <div className={'lz-form-page lz-form-page-full'}>
                    <Container>

                        <UpdateProfileComponent />

                    </Container>
                </div>
            </PrivateLayout>
        );
    }

}

export default UpdateProfileScreen;
